import { useState, useEffect, DependencyList } from "react";

export function useFetch<T>(
  fetchFn: () => Promise<T>,
  deps: DependencyList
) {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    const doFetch = async () => {
      setLoading(true);
      setError(null);
      try {
        const result = await fetchFn();
        if (!cancelled) setData(result);
      } catch (err: any) {
        if (!cancelled) setError(err.message || "An error occurred");
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    doFetch();

    return () => {
      cancelled = true;
    };
  }, deps);

  return { data, loading, error };
}
